import { createSlice } from "@reduxjs/toolkit";

export const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    isLoading: false,
    isError: false,
    message: "",
    status_code: 0,
  },
  reducers: {
    onResetPassword: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        message: "",
        status_code: 0,
      };
    },
    onResetPasswordSuccess: (state, { payload }) => {
      const { message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        message,
        status_code,
      };
    },
    onResetPasswordError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: true,
        message,
        status_code,
      };
    },
    onResetPasswordReset: (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        message: "",
        status_code: 0,
      };
    },
  },
});

export const {
  onResetPassword,
  onResetPasswordSuccess,
  onResetPasswordError,
  onResetPasswordReset,
} = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
